import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconChevronRightMedium: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"chevron-right-medium"} maskId="square-filled-radius-0-stroke-1-IconChevronRightMedium"><path d="M16.707 12L9.5 19.207L8.79297 18.5L15.293 12L8.79297 5.5L9.5 4.79297L16.707 12Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconChevronRightMedium;
